import {useContext} from "react"
import ModalContext from "../contexts/ModalContext"

export default function useModal(){

    const [modalContext,setModalContext]=useContext(ModalContext)
    // Helper to get the modal element safely
    const getModalEl = () => document.getElementById("modal")
    // Store timer id on the element to keep it stable across renders/closures
    const clearFallbackTimer = (el) => {
        try{
            if(el && el.dataset && el.dataset.modalTimerId){
                const id = Number(el.dataset.modalTimerId)
                if(!Number.isNaN(id)) clearTimeout(id)
                delete el.dataset.modalTimerId
            }
        }catch(e){/* noop */}
    }

    const changeModal=(modal,context,reference)=>{
        let modalContextNew={...modalContext}
        modalContextNew["modal"]=modal
        modalContextNew["context"]=context
        modalContextNew["reference"]=reference
        setModalContext(modalContextNew)
        manageModal("show")
    }

    const modalReady=(ready)=>{
        let modalContextNew={...modalContext}
        modalContextNew["ready"]=ready
        setModalContext(modalContextNew)
        const el = getModalEl()
        // When a modal component signals it's ready, make the modal visible (smoothly).
        if(ready===1){
            // clear any fallback timer and show content
            clearFallbackTimer(el)
            if(el){
                if(el.classList.contains("modal-loading")) el.classList.remove("modal-loading")
                if(!el.classList.contains("modal-show")) el.classList.add("modal-show")
            }
        }else{
            // Not ready: add a loading state to avoid showing an incomplete/small window
            if(el){
                if(!el.classList.contains("modal-loading")) el.classList.add("modal-loading")
                if(el.classList.contains("modal-show")) el.classList.remove("modal-show")
            }
        }
    }

    const manageModal=(action)=>{
        if(action==="show"){
            const el = getModalEl()
            if(!el) return
            el.style.display="block"
            if(!el.classList.contains("modal-loading")) el.classList.add("modal-loading")
            clearFallbackTimer(el)
            const id = setTimeout(()=>{
                const el2 = getModalEl()
                if(el2 && el2.classList.contains("modal-loading")){
                    try{ console.warn("Modal fallback: forcing show after timeout") }catch(e){}
                    el2.classList.remove("modal-loading")
                    if(!el2.classList.contains("modal-show")) el2.classList.add("modal-show")
                }
                clearFallbackTimer(el2)
            }, 4000)
            if(el && el.dataset){ el.dataset.modalTimerId = String(id) }
        }else if(action==="hide"){
            const el = getModalEl()
            if(el){
                clearFallbackTimer(el)
                el.classList.remove("modal-show")
                el.classList.remove("modal-loading")
            }
            const id = setTimeout(()=>{
                const el2 = getModalEl()
                if(el2) el2.style.display="none"
                let modalContextNew={...modalContext}
                modalContextNew["modal"]=""
                modalContextNew["context"]=""
                modalContextNew["reference"]=""
                modalContextNew["ready"]=1
                setModalContext(modalContextNew)
                clearFallbackTimer(el2)
            },250)
            if(el && el.dataset){ el.dataset.modalTimerId = String(id) }
        }
    }

    return {manageModal,changeModal,modalReady}
    
}